import { InputCheckBox } from "@itandi/itandi-bb-ui";
import clsx from "clsx";
import { useCallback } from "react";
import type { CompanyStoreMail } from "~/models/CompanyStoreMail";
import Styles from "./CompanyStoreMailList.module.scss";

type Props = {
	checkNumbers: number[];
	companyMails: CompanyStoreMail[] | null;
	onCheckChange: (id: number) => void;
};

export function CompanyStoreMailList({
	companyMails,
	checkNumbers,
	onCheckChange
}: Props) {
	const renderRow = useCallback(
		(companyMail: CompanyStoreMail) => (
			<tr className={Styles.ListRow} key={companyMail.id}>
				{companyMails !== null && (
					<td className={Styles.DropdownCheck}>
						<InputCheckBox
							checked={checkNumbers.includes(companyMail.id)}
							onChange={(): void => {
								onCheckChange(companyMail.id);
							}}
						/>
					</td>
				)}
				<td className={Styles.ListCol}>{companyMail.email}</td>
			</tr>
		),
		[checkNumbers, companyMails, onCheckChange]
	);
	const isChecked = checkNumbers.length > 0;
	return (
		<table className={Styles.List}>
			<thead>
				<tr className={clsx(Styles.ListRow, Styles.Header)}>
					{companyMails?.length !== 0 && <th />}
					<th>
						メールアドレス
						{isChecked ? <>: {checkNumbers.length}件削除します</> : null}
					</th>
				</tr>
			</thead>
			<tbody>{companyMails?.map(renderRow)}</tbody>
		</table>
	);
}
